import { isPlanSectionsDocked, requestPlanSectionDialog } from './planSectionDialog'

const P360_TABS_ELEMENT_ID = 'P360Tabs'
const DEFAULT_SCROLL_OFFSET = 150

export const scrollToP360Tabs = (scrollOffset = DEFAULT_SCROLL_OFFSET) => {
  if (isPlanSectionsDocked()) {
    requestPlanSectionDialog()
    return
  }

  const tabsElement = document.getElementById(P360_TABS_ELEMENT_ID)

  if (!tabsElement) {
    return
  }

  window.scrollTo({
    top: tabsElement.getBoundingClientRect().top + window.scrollY - scrollOffset,
  })
}
